import React, { Component } from 'react';

import ParsedMarkdown from './ParsedMarkdown';

class RichText extends Component {
  render() {
    const { anchor, richTextCopy } = this.props;
    return (
      <section id={anchor || undefined} className="rich-text">
        <ParsedMarkdown options={{ forceBlock: true }}>
          {richTextCopy.markdown}
        </ParsedMarkdown>
      </section>
    );
  }
}

export default RichText;
